import styles from './Menu.module.css';

const Menu = ({ children }) => {
  return <ul className={styles.host}>{children}</ul>;
};

export default Menu;
